<template >
    <div class="product-list-element" >
        <img class="cdn-image" :src="cdnImage"/>
        <div class="details-box" >
            <div class="display-series">{{product.salesName}}</div>
            <div class="availaibilty-message"  :key="availabilityObject.sku">

                <img v-if="getAmountClass(product) === 'availability-low'" class="availability-noticer" src="@/assets/GreenInfoSmall.svg"/>
                <div :class="getAmountClass(product)">{{availabilityObject.state.message}}
                    <span v-if="getAmountClass(product) === 'availability-available'">( {{ getAvailable(product) }} )</span>
                    <span v-else> {{ getAvailable(product) }} </span>
                </div>


            </div>
            <div class="sku">{{product.defaultPrice}}</div>
        </div>
        <div class="pricing-box" style="flex-direction: row; align-items: center;" >

            <img  v-if="added" style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="removeFocusProduct" src="@/assets/RemoveCart.svg"/>

            <div class="form-row-element-small" style="width: 80px;display: flex;">
                <BaseInput v-model="focusPrice"  placeholder=""/>
            </div>
            <img  v-if="!added" style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="addFocusProduct" src="@/assets/PlusGreen.svg"/>
            <img  v-else style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="addFocusProduct" src="@/assets/Save.svg"/>
        </div>



        <div>

        </div>
    </div>

</template>

<script>
    import BaseInput from "@/components/forms/inputs/BaseInput";
 export default {
     name: "ProductFocusListElement",
     components: {BaseInput},
     data(){
         return {
             focusPrice: 0
         }

     },
     props: {
         updating: { type: Boolean, default: false },
         line_type: {type: Number, default:1},
         product: {
             avatar: '',
             salesName:'',
             defaultPrice: 0,
             displaySeries:'',
             SKU:'',
             availability: {
                 state: {
                     state: "active",
                     message: "Tilgjengelig",
                     buyable: true
                 },
                 roof: 250,
                 qty: 190
             }
         },
         party:null

     },
     computed:{
         cdnImage(){
             let avatarFile = ''
             if(this.product.images.productMain != null){
                 if(this.product.images.productMain.length > 0){
                     if(this.product.images.productMain[0].image){
                         avatarFile = this.product.images.productMain[0].image.name
                     }
                 }
             }
             return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
         },
         seriesIdentifier(){
             return this.product.displaySeries.toUpperCase()
             // return this.product.salesName.substr(0, this.product.salesName.indexOf(' ')).toUpperCase()
         },
         added(){
            return  this.party.focusProducts.filter((el)=>{ return this.product.SKU === el.productId.toString()}).length > 0
         },
         availabilityObject(){
             return this.$store.getters.getStockItem(this.product.SKU)
         }

     },
     methods: {
         scrollToTop() {
             window.scrollTo(0,0);
         },
         removeFocusProduct(){
                this.$emit('remove-focus-product', this.product.SKU)
         },
         addFocusProduct(){
             this.$emit('add-focus-product', this.product.SKU, this.focusPrice)
         },
         getAmountClass(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return 'availability-unbuyable'
             }
             if(stockObj.state.buyable){
                 if(stockObj.qty <= 0){
                     return 'availability-unavailable'
                 }else if(stockObj.qty < 15){
                     return 'availability-low'
                 }else {
                     return 'availability-available'
                 }
             }else{
                 return 'availability-unbuyable'
             }
         },
         getAvailable(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return '0'
             }
             if (!stockObj.state.buyable) {
                 return '0'
             } else {
                 if (stockObj.qty <= 0){
                     return '0'
                 } else {
                     if (stockObj.qty > stockObj.roof){
                         return '> ' + stockObj.displayQty
                     } else {
                         return stockObj.qty
                     }
                 }
             }
         }

     },
     mounted(){
         if(this.party){
            let existing = this.party.focusProducts.filter((el)=>{ return this.product.SKU === el.productId.toString()})
            if(existing.length > 0){
                this.focusPrice = existing[0].offerprice
            }

         }
     }

 }
</script>

<style scoped>
.input-wrapper{
    height:60px;
}
</style>
